import { PAYMENTS_ROUTES } from '../../constants/_routes'
import paymentsTypes from '../../constants/paymentsTypes'
import { axios } from '../../services'

// INDEX
const payments_export_request = () => {
  return {
    type: paymentsTypes.export.request
  }
}

const payments_export_success = () => {
  return {
    type: paymentsTypes.export.success
  }
}

const payments_export_failure = (messages) => {
  return {
    type: paymentsTypes.export.failure,
    payload: messages
  }
}

const payments_xlsx = (filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(payments_export_request())
    document.body.classList.add('instalevel-fetching-data')

    axios.get(
      `${PAYMENTS_ROUTES.index}.xlsx`,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters
        },
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const filename = 'payments.xlsx'
      const blob = URL.createObjectURL(response.data, "mitsos")
      let fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = filename
      fileLink.click();
      URL.revokeObjectURL(blob)
      dispatch( payments_export_success() )
      document.body.classList.remove('instalevel-fetching-data')
    }).catch( error=> {
      // failure
      document.body.classList.remove('instalevel-fetching-data')
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching xlsx file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( payments_export_failure(errors))
    })
  }

}

export {
  payments_xlsx
}



// WEBPACK FOOTER //
// ./src/js/actions/payments/getxlsx.js